var _polyline, _polyline2, _polyline3, _polyline4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgContacts(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 150 195",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Contacts") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(-2.457700, -0.680968)",
    stroke: "currentcolor"
  }, _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    id: "Path-2",
    strokeWidth: 5,
    transform: "translate(83.654270, 107.124462) rotate(-3.000000) translate(-83.654270, -107.124462) ",
    points: "22.4838041 189.574746 144.824735 189.574746 144.824735 24.6741777 129.151979 24.6741777"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M127.70952,7.66696192 L127.70952,67.1653749 L110.098882,67.1653749 L110.098882,174.666962 L16.0843665,174.666962 C13.5504529,175.235105 11.4781926,176.139724 9.83685994,177.335537 L9.785,177.373 L9.77052458,176.596234 C9.08802132,141.197843 8.73549233,116.841437 8.71318473,96.2594853 L8.71256345,95.5748082 L8.71256276,92.8081287 C8.72918298,70.4027129 9.1531685,52.1453764 9.98417935,28.0729165 C10.193665,22.0046029 11.6310681,16.4661911 15.178325,12.678967 C18.1574522,9.49830576 22.6189225,7.66696192 28.8594617,7.66696192 L28.8594617,7.66696192 L127.70952,7.66696192 Z",
    id: "Rectangle-Copy-26",
    strokeWidth: 5,
    style: {
      fill: "var(--tab-icon-fill-color, #fff)"
    },
    transform: "translate(68.210787, 96.385446) rotate(-4.000000) translate(-68.210787, -96.385446) "
  }), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    id: "Path-3",
    transform: "translate(129.073985, 116.905909) rotate(-3.000000) translate(-129.073985, -116.905909) ",
    points: "138.789214 65.4059086 138.789214 168.405909 119.358756 168.405909"
  })), _polyline3 || (_polyline3 = /*#__PURE__*/React.createElement("polyline", {
    id: "Path-3-Copy",
    transform: "translate(125.202322, 65.690738) rotate(-3.000000) translate(-125.202322, -65.690738) ",
    points: "133.202322 31.6907375 133.202322 99.6907375 117.202322 99.6907375"
  })), _polyline4 || (_polyline4 = /*#__PURE__*/React.createElement("polyline", {
    id: "Path-4",
    transform: "translate(127.329700, 120.632638) rotate(-3.000000) translate(-127.329700, -120.632638) ",
    points: "119.614471 135.154553 135.044929 135.154553 135.044929 106.110723"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContacts);
export default __webpack_public_path__ + "static/media/contacts.28440fe4c8c17f5d29d879397b7db8a1.svg";
export { ForwardRef as ReactComponent };